<template>
  <div class="post-webwidget-v2-now-playing-detail-wrapper">
    <div class="post-webwidget-v2-now-playing-detail-show-title">
      <div>{{ showTitle || (station ? station.toUpperCase() : '') }}</div>
    </div>
    <div class="post-webwidget-v2-now-playing-detail-episode-name">
      {{ episodeName }}&nbsp;
    </div>
    <div class="post-webwidget-v2-now-playing-detail-audio-player">
      <live-audio-player
        :dark-theme="darkTheme"
        :autoplay="episodeAutoPlay"
        :audio-file-src="episodeAudioFileSrc"
        :playing-live-stream="playingLiveStream"
        @pause="onAudioPause"
        @play="onAudioPlay"
        @ready="onLiveAudioPlayerReady"
        @episode-ended="$emit('episode-ended')"
      ></live-audio-player>
    </div>
  </div>
</template>

<script>
import LiveAudioPlayer from './LiveAudioPlayer';

export default {
  name: 'now-playing-detail',
  // Vue3 (LP-4/MR-78, the LP-2-deferred emits item): declare the $emitted events
  // (the `audio:${action}` pair resolves to audio:play/audio:pause) so parent
  // listeners bind as component events, not native-attr fallthrough.
  emits: ['audio:pause', 'audio:play', 'audio-player:ready', 'episode-ended'],
  components: {
    LiveAudioPlayer,
  },
  props: {
    darkTheme: Boolean,
    showTitle: String,
    station: String,
    episodeName: String,
    episodeAudioFileSrc: String,
    playingLiveStream: Boolean,
    episodeAutoPlay: {
      type: Boolean,
      default: false, // 0 instead of false because Chrome doesn't understand false
    },
  },
  methods: {
    emitAudioPlayerAction(action) {
      this.$emit(`audio:${action}`);
    },
    onAudioPause() {
      this.emitAudioPlayerAction('pause');
    },
    onAudioPlay() {
      this.emitAudioPlayerAction('play');
    },
    onLiveAudioPlayerReady(audioPlayerRef) {
      this.$emit('audio-player:ready', audioPlayerRef);
    },
  },
};
</script>

<style lang="scss" scoped>
.post-webwidget-v2-now-playing-detail-wrapper {
  margin: 1em;

  .post-webwidget-v2-now-playing-detail {
    &-show-title {
      margin-bottom: 0.5em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-episode-name {
      font-size: 1.2em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-audio-player {
      //
    }
  }
}
</style>
